import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
/* eslint-disable no-undef */
import * as API from '~/api';

// Global declarations

// Type definitions

// API Model interface for type safety

// Recursion prevention utility
var recursionTracker = {
  activeEmissions: new Map(),
  maxDepth: 3,
  canEmit: function canEmit(model, id, source) {
    var key = "".concat(model, ":").concat(id);
    var current = this.activeEmissions.get(key) || {
      count: 0,
      sources: []
    };

    // Check if we're already processing this model/id combination
    if (current.count >= this.maxDepth) {
      console.warn("Potential recursion detected for ".concat(model, ":").concat(id, ". Emission blocked."), {
        count: current.count,
        sources: current.sources,
        newSource: source
      });
      return false;
    }

    // Check if the same source is trying to emit again
    if (source && current.sources.includes(source)) {
      console.warn("Circular emission detected from source ".concat(source, " for ").concat(model, ":").concat(id, ". Emission blocked."));
      return false;
    }
    return true;
  },
  trackEmission: function trackEmission(model, id, source) {
    var _this = this;
    var key = "".concat(model, ":").concat(id);
    var current = this.activeEmissions.get(key) || {
      count: 0,
      sources: []
    };
    this.activeEmissions.set(key, {
      count: current.count + 1,
      sources: source ? [].concat(_toConsumableArray(current.sources), [source]) : current.sources
    });

    // Clean up after a short delay
    setTimeout(function () {
      var updated = _this.activeEmissions.get(key);
      if (updated && updated.count > 0) {
        updated.count--;
        if (source) {
          updated.sources = updated.sources.filter(function (s) {
            return s !== source;
          });
        }
        if (updated.count === 0) {
          _this.activeEmissions.delete(key);
        } else {
          _this.activeEmissions.set(key, updated);
        }
      }
    }, 100);
  }
};

// Listener tracking utility
var listenerTracker = {
  maxListeners: 30,
  activeListeners: new Map(),
  listenerOrder: [],
  addListener: function addListener(uuid, model, name, callback) {
    var listenerId = "".concat(uuid, "_").concat(model, "_").concat(name, "_").concat(Date.now());
    var listenerData = {
      id: listenerId,
      uuid: uuid,
      model: model,
      name: name,
      callback: callback,
      createdAt: Date.now()
    };

    // Add to tracking
    this.activeListeners.set(listenerId, listenerData);
    this.listenerOrder.push(listenerId);

    // Check if we exceed the limit
    if (this.listenerOrder.length > this.maxListeners) {
      this.removeOldestListener();
    }
    if (process.env.NODE_ENV === 'development') {
      console.log("[EventBus] Added listener ".concat(listenerId, ". Total active: ").concat(this.activeListeners.size));
    }
    return listenerId;
  },
  removeListener: function removeListener(listenerId) {
    var listener = this.activeListeners.get(listenerId);
    if (listener) {
      // Remove from Nuxt event system
      $nuxt.$off(listener.name, listener.callback);

      // Remove from tracking
      this.activeListeners.delete(listenerId);
      this.listenerOrder = this.listenerOrder.filter(function (id) {
        return id !== listenerId;
      });
      if (process.env.NODE_ENV === 'development') {
        console.log("[EventBus] Removed listener ".concat(listenerId, ". Total active: ").concat(this.activeListeners.size));
      }
      return true;
    }
    return false;
  },
  removeOldestListener: function removeOldestListener() {
    if (this.listenerOrder.length > 0) {
      var oldestId = this.listenerOrder[0];
      var removed = this.removeListener(oldestId);
      if (removed && process.env.NODE_ENV === 'development') {
        console.log("[EventBus] Removed oldest listener ".concat(oldestId, " due to limit (").concat(this.maxListeners, ")"));
      }
    }
  },
  removeListenersByUuid: function removeListenersByUuid(uuid) {
    var _this2 = this;
    var toRemove = [];
    var _iterator = _createForOfIteratorHelper(this.activeListeners),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          _listenerId = _step$value[0],
          listener = _step$value[1];
        if (listener.uuid === uuid) {
          toRemove.push(_listenerId);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    toRemove.forEach(function (id) {
      return _this2.removeListener(id);
    });
    return toRemove.length;
  },
  getStats: function getStats() {
    return {
      total: this.activeListeners.size,
      maxListeners: this.maxListeners,
      listeners: Array.from(this.activeListeners.values()).map(function (l) {
        return {
          id: l.id,
          uuid: l.uuid,
          model: l.model,
          name: l.name,
          createdAt: l.createdAt,
          age: Date.now() - l.createdAt
        };
      })
    };
  },
  clear: function clear() {
    // Remove all listeners from Nuxt event system
    var _iterator2 = _createForOfIteratorHelper(this.activeListeners.values()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var listener = _step2.value;
        $nuxt.$off(listener.name, listener.callback);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    this.activeListeners.clear();
    this.listenerOrder = [];
    if (process.env.NODE_ENV === 'development') {
      console.log('[EventBus] Cleared all tracked listeners');
    }
  }
};
export default (function (context, inject) {
  var events = ['updated', 'created', 'deleted'];
  var notification = function notification(model, type) {
    var item = API[model];
    switch (type) {
      case 'deleted':
        return item.deletedNotificationName();
      case 'created':
        return item.createdNotificationName();
      default:
        return item.updatedNotificationName();
    }
  };
  var plugin = {
    listeners: {},
    // Development helper for debugging
    debug: {
      enabled: process.env.NODE_ENV === 'development',
      log: function log(message, data) {
        if (this.enabled) {
          console.log("[EventBus] ".concat(message), data);
        }
      },
      getActiveEmissions: function getActiveEmissions() {
        return recursionTracker.activeEmissions;
      },
      clearActiveEmissions: function clearActiveEmissions() {
        recursionTracker.activeEmissions.clear();
      },
      getListenerStats: function getListenerStats() {
        return listenerTracker.getStats();
      },
      clearAllListeners: function clearAllListeners() {
        listenerTracker.clear();
      },
      setMaxListeners: function setMaxListeners(max) {
        listenerTracker.maxListeners = max;
      }
    },
    emit: _objectSpread({}, Object.fromEntries(events.map(function (event) {
      return [event, function (model, data) {
        var _data$objectID;
        var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        // Extract ID for recursion tracking
        var id = data === null || data === void 0 ? void 0 : (_data$objectID = data.objectID) === null || _data$objectID === void 0 ? void 0 : _data$objectID.call(data);

        // Check if emission should be allowed
        if (!recursionTracker.canEmit(model, id, source)) {
          return false;
        }

        // Track this emission
        recursionTracker.trackEmission(model, id, source);
        var name = notification(model, event);
        var eventData = {
          data: data,
          source: source,
          timestamp: Date.now()
        };
        $nuxt.$emit(name, eventData);
        return true;
      }];
    }))),
    on: _objectSpread(_objectSpread({}, Object.fromEntries(events.map(function (event) {
      return [event, function (model, uuid, callback) {
        var name = notification(model, event);
        var wrappedCallback = function wrappedCallback(eventData) {
          // Handle both old format (direct data) and new format (wrapped data)
          var data = (eventData === null || eventData === void 0 ? void 0 : eventData.data) !== undefined ? eventData.data : eventData;
          var source = (eventData === null || eventData === void 0 ? void 0 : eventData.source) || null;
          if (callback instanceof Function) {
            callback(data, source, eventData === null || eventData === void 0 ? void 0 : eventData.timestamp);
          }
        };
        $nuxt.$on(name, wrappedCallback);

        // Track the listener with the new system
        var listenerId = listenerTracker.addListener(uuid, model, name, wrappedCallback);

        // Keep the old system for backward compatibility
        plugin.add(name, model, uuid, wrappedCallback, listenerId);
      }];
    }))), {}, {
      all: function all(model, uuid, callback) {
        events.forEach(function (event) {
          var name = notification(model, event);
          var wrappedCallback = function wrappedCallback(eventData) {
            // Handle both old format (direct data) and new format (wrapped data)
            var data = (eventData === null || eventData === void 0 ? void 0 : eventData.data) !== undefined ? eventData.data : eventData;
            var source = (eventData === null || eventData === void 0 ? void 0 : eventData.source) || null;
            if (callback instanceof Function) {
              callback(data, source, eventData === null || eventData === void 0 ? void 0 : eventData.timestamp);
            }
          };
          $nuxt.$on(name, wrappedCallback);

          // Track the listener with the new system
          var listenerId = listenerTracker.addListener(uuid, model, name, wrappedCallback);

          // Keep the old system for backward compatibility
          plugin.add(name, model, uuid, wrappedCallback, listenerId);
        });
      }
    }),
    once: _objectSpread({}, Object.fromEntries(events.map(function (event) {
      return [event, function (model, callback) {
        var name = notification(model, event);
        var wrappedCallback = function wrappedCallback(eventData) {
          // Handle both old format (direct data) and new format (wrapped data)
          var data = (eventData === null || eventData === void 0 ? void 0 : eventData.data) !== undefined ? eventData.data : eventData;
          var source = (eventData === null || eventData === void 0 ? void 0 : eventData.source) || null;
          if (callback instanceof Function) {
            callback(data, source, eventData === null || eventData === void 0 ? void 0 : eventData.timestamp);
          }
        };
        $nuxt.$once(name, wrappedCallback);

        // Note: $once listeners are automatically removed after firing,
        // so we don't need to track them in our system
      }];
    }))),
    off: _objectSpread(_objectSpread({}, Object.fromEntries(events.map(function (event) {
      return [event, function (uuid) {
        var _plugin$listeners$uui2;
        // Remove from new tracking system
        var removedCount = listenerTracker.removeListenersByUuid(uuid);

        // Keep old system for backward compatibility
        var listener = plugin.listeners[uuid];
        if (listener) {
          listener.forEach(function (listener, index) {
            var name = notification(listener.model, event);
            if (name === listener.name) {
              var _plugin$listeners$uui;
              // Note: listener is already removed by listenerTracker
              (_plugin$listeners$uui = plugin.listeners[uuid]) === null || _plugin$listeners$uui === void 0 ? void 0 : _plugin$listeners$uui.splice(index, 1);
            }
          });
        }
        if (((_plugin$listeners$uui2 = plugin.listeners[uuid]) === null || _plugin$listeners$uui2 === void 0 ? void 0 : _plugin$listeners$uui2.length) === 0) {
          delete plugin.listeners[uuid];
        }
        return removedCount;
      }];
    }))), {}, {
      all: function all(uuid) {
        // Remove from new tracking system
        var removedCount = listenerTracker.removeListenersByUuid(uuid);

        // Keep old system for backward compatibility
        var listener = plugin.listeners[uuid];
        if (listener) {
          listener.forEach(function (listener) {
            // Note: listeners are already removed by listenerTracker
          });
        }
        delete plugin.listeners[uuid];
        return removedCount;
      }
    }),
    add: function add(name, model, uuid, callback) {
      var listenerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      if (!plugin.listeners[uuid]) {
        plugin.listeners[uuid] = [];
      }
      plugin.listeners[uuid].push({
        model: model,
        name: name,
        uuid: uuid,
        callback: callback,
        listenerId: listenerId
      });
    }
  };
  inject('bus', plugin);
});

// Type augmentation for better IDE support